export const IMAGE_SIZE_MAX = 5;
export const defaultPhotoTypes = 'image/jpeg, image/jpg, image/png, image/bmp';
export const defaultPhotoTypesWithoutImage = 'jpg, jpeg, png, bmp';
